export default {
  article_breadcrumb_home: 'Inicio',
  article_breadcrumb_current: 'Guía de USFans Spreadsheet',
  article_category: 'Guías',
  article_reading_time: '8 min de lectura',
  article_updated: 'Actualizado',
  article_title: 'Guía de USFans Spreadsheet: qué es y cómo usarla',
  article_lead:
    'Una hoja de cálculo USFans es una forma sencilla y estructurada de organizar e investigar información de productos, vendedores y recursos. Esta guía explica qué es, por qué se usa y cómo sacarle el máximo partido, paso a paso.',

  article_h2_1: '¿Qué es una hoja de cálculo USFans?',
  article_p_1:
    'Una hoja de cálculo USFans es una forma estructurada de organizar e investigar información de productos, vendedores y recursos en un solo lugar. En lugar de saltar entre páginas dispersas, puedes usar recursos organizados para descubrir información, comparar opciones y continuar tu investigación de forma más eficiente.',
  article_p_2:
    'Piensa en ella como un mapa de investigación: agrupa elementos relacionados para que veas rápidamente qué hay disponible, compares detalles y decidas dónde buscar a continuación. La hoja en sí es una forma de organizar la información, mientras que los productos y precios actuales viven en el sitio principal.',

  article_h2_2: '¿Por qué usar una hoja de cálculo USFans?',
  article_p_3:
    'Las personas usan hojas de cálculo para ahorrar tiempo y mantenerse organizadas. Cuando investigas muchos productos o vendedores a la vez, un diseño estructurado te ayuda a comparar opciones sin perder de vista lo que ya has revisado.',
  article_li_1: 'Organiza muchos productos y categorías en una sola vista',
  article_li_2: 'Compara productos, vendedores y recursos uno al lado del otro',
  article_li_3: 'Mantén tus notas de investigación en un lugar consistente',
  article_li_4: 'Pasa de la investigación al sitio principal más rápido',

  article_h2_3: 'Cómo usar una hoja de cálculo USFans (paso a paso)',
  article_step_1_title: 'Elige una categoría',
  article_step_1_desc: 'Empieza con una categoría como Zapatos, Camisetas o Bolsos para acotar tu búsqueda.',
  article_step_2_title: 'Compara las opciones',
  article_step_2_desc: 'Mira los distintos elementos y anota los detalles que te importan.',
  article_step_3_title: 'Verifica la información',
  article_step_3_desc: 'Comprueba siempre enlaces, vendedores y detalles de productos de forma independiente.',
  article_step_4_title: 'Continúa al sitio principal',
  article_step_4_desc: 'Cuando estés listo, sigue los enlaces al sitio principal para explorar más.',

  article_h2_4: 'Una comparación rápida',
  article_compare_col_feature: 'Característica',
  article_compare_col_a: 'Investigación en hoja',
  article_compare_col_b: 'Investigación de vendedor',
  article_cr1_label: 'Profundidad de información',
  article_cr1_a: 'Alta',
  article_cr1_b: 'Media',
  article_cr2_label: 'Facilidad de uso',
  article_cr2_a: 'Fácil',
  article_cr2_b: 'Moderada',
  article_cr3_label: 'Ideal para',
  article_cr3_a: 'Comparar productos',
  article_cr3_b: 'Verificar vendedores',

  article_h2_5: 'Consejos de seguridad',
  article_p_4:
    'Antes de usar cualquier hoja de cálculo, enlace de producto o información de vendedor, tómate un momento para verificar la fuente. Unos pocos hábitos sencillos te ayudarán a evitar errores comunes.',
  article_safe_1: 'Verifica los enlaces antes de hacer clic o comprar',
  article_safe_2: 'Nunca compartas contraseñas ni información personal sensible',
  article_safe_3: 'Ten cuidado con páginas no oficiales que copian una marca real',
  article_safe_4: 'Comprueba precios, envío y stock en el sitio principal',

  article_h2_6: 'Preguntas frecuentes',
  article_faq_q1: '¿Es gratis usar una hoja de cálculo USFans?',
  article_faq_a1:
    'Usar una hoja organizada como ayuda para la investigación es gratis. Los precios, el envío y la disponibilidad reales se muestran en el sitio principal.',
  article_faq_q2: '¿Dónde encuentro los últimos productos?',
  article_faq_a2:
    'Los productos y precios más actuales están en el sitio principal. Usa las categorías de aquí para saltar directamente a la sección que necesitas.',
  article_faq_q3: '¿Necesito una cuenta?',
  article_faq_a3:
    'Para navegar por los recursos de aquí no se necesita cuenta. El sitio principal puede tener sus propios requisitos.',

  article_cta_title: 'Continúa tu investigación',
  article_cta_body:
    'Explora categorías y recursos organizados, y continúa al sitio principal cuando estés listo.',
  article_cta_primary: 'Explora USFans Spreadsheet',
  article_cta_secondary: 'Volver a la página principal',
  article_not_found: 'Artículo no encontrado',
  article_not_found_desc:
    'No se pudo encontrar el artículo que buscas. Explora nuestras guías desde la página principal.',
  article_related: 'Guías relacionadas',

  article_disclaimer:
    'Aviso: USFansLink.boats es un recurso informativo independiente y no es el sitio oficial de USFans. Verifica siempre de forma independiente vendedores, enlaces, productos, precios, información de envío y detalles de transacción antes de tomar una decisión.',
};